<template>
  <v-menu 
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-y
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="error">
          mdi-delete
        </v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-text> Are you sure you want to delete <b>{{ taskCategory.name.toUpperCase() }}</b> task category? </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="menu = false"
        >
          No
        </v-btn>
        <v-btn
          color="success"          
          @click="submitForm"
        >
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
  export default {
    props: {
      taskCategory: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        menu: null,
      }
    },
    methods: {
      submitForm () {
        this.$api.taskCategories().delete(this.taskCategory.id)
          .then(response => {
            this.$emit('deleted')
            this.$snack({ message: response.data.status })
          })  
      },
    },
  }
</script>
